<!-- eslint-disable svelte/no-restricted-html-elements -- 
 No link l10n needed, Link component messes up the rich text -->
<p>
	The latest AI systems can already analyze and write software. They <a
		href="https://betterprogramming.pub/i-used-gpt-3-to-find-213-security-vulnerabilities-in-a-single-codebase-cc3870ba9411"
		>can find vulnerabilities</a
	>
	in software, and
	<a
		href="https://blog.checkpoint.com/2023/03/15/check-point-research-conducts-initial-security-analysis-of-chatgpt4-highlighting-potential-scenarios-for-accelerated-cybercrime/"
		>they could be used to exploit them</a
	>. As AI capabilities grow, so will the vulnerabilities they can detect and the exploits they can
	create. They are not yet as good at this as the best humans are, so right now the danger is
	limited. However, capabilities are rapidly increasing.
</p>
<p>
	Note that AI also enables completely novel types of attacks. For example, AI can be used to <a
		href="https://beebom.com/ai-crack-password-listening-keyboard-sounds/"
		>hear the password you typed from an online call</a
	>
	or use
	<a
		href="https://www.marktechpost.com/2023/02/15/cmu-researchers-create-an-ai-model-that-can-detect-the-pose-of-multiple-humans-in-a-room-using-only-the-signals-from-wifi/"
		>Wi-Fi to see humans through walls</a
	>. AI can also be used to make
	<a href="https://www.hyas.com/blog/blackmamba-using-ai-to-generate-polymorphic-malware"
		>self-modifying malware</a
	>, which makes it far harder to detect.
</p>
<p>
	There will most likely come a point where an AI is better at hacking than the best human hackers.
	This can go wrong in many ways.
</p>
<ul>
	<li>
		<strong>Infrastructure</strong>: Cyberweapons can be used to gain access to or disable critical
		infrastructure, such as
		<a href="https://en.wikipedia.org/wiki/Colonial_Pipeline_ransomware_attack">oil pipelines</a>.
	</li>
	<li>
		<strong>Financial</strong>: Cyberweapons can be used to
		<a href="https://en.wikipedia.org/wiki/2015%E2%80%932016_SWIFT_banking_hack"
			>steal money from banks</a
		>, or to
		<a href="https://en.wikipedia.org/wiki/2010_flash_crash">manipulate the stock market</a>.
	</li>
	<li>
		<strong>Military</strong>: Equipment such as weapons and sensors are increasingly dependent on
		wireless connectivity and complex software.
	</li>
	<ul></ul>
</ul>
